import React, { useState, useEffect } from "react";
import { Box, Table, TableBody, TableCell, TableContainer, TableRow, IconButton, Typography, TextField, Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

export default function PersonalInformation() {
  // State to hold user data
  const [data, setData] = useState({
    user_id: "",
    fullName: "",
    username: "",
    email: "",
    phone: "",
    company: "",
  });

  // Edit mode state
  const [isEditing, setIsEditing] = useState(false);

  // Fetching user data from localStorage when the component mounts
  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      const userData = JSON.parse(user);
      setData({
        user_id: userData._id || "",
        fullName: userData.fullName || "",
        username: userData.username || "",
        email: userData.email || "",
        phone: userData.phone || "",
        company: userData.company || "",
      });
    }
  }, []);

  // Edit handler
  const handleEditClick = () => {
    setIsEditing(true);
  };

  // Change handler for input fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({
      ...data,
      [name]: value,
    });
  };

  // Update Profile API Request
  const handleUpdateClick = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL; // Ensure your .env file is properly set
      const response = await fetch(`${apiUrl}/user/${data.user_id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fullName: data.fullName, // Match the field name expected by your API
          username: data.username,
          email: data.email,
          phone: data.phone,
          company: data.company,
        }),
      });
  
      const result = await response.json();
  
      if (response.ok) {
        alert("Profile updated successfully!");
  
        // Update localStorage with new data
        localStorage.setItem("user", JSON.stringify({ ...data, ...result.data }));
  
        // Update state
        setData({ ...data, ...result.data });
        setIsEditing(false);
      } else {
        alert(result.message || "An error occurred. Please try again.");
      }
    } catch (error) {
      console.error("Update error:", error);
      alert("An error occurred while updating. Please try again.");
    }
  };

  return (
    <Box className="personalTable">
      <Typography className="tableHeading" variant="h6" gutterBottom sx={{ padding: "10px 15px", backgroundColor: "#EBEBEB", fontSize:{xs:"16px",sm:"17px",md:"1.25rem" }}}>
        Personal Information
        <IconButton sx={{ marginLeft: 5 }} onClick={handleEditClick}>
          <EditIcon />
        </IconButton>
      </Typography>
      <TableContainer sx={{ maxWidth: 600 }}>
        <Table>
          <TableBody sx={{ backgroundColor: "#F8F8F8" }}>
            <TableRow>
              <TableCell className="perTblLabel">Full Name:</TableCell>
              <TableCell className="perTbUsrInfo">
                {isEditing ? (
                  <TextField name="fullName" value={data.fullName} onChange={handleChange} fullWidth variant="outlined" />
                ) : (
                  data.fullName
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="perTblLabel">Username:</TableCell>
              <TableCell className="perTbUsrInfo">
                {isEditing ? (
                  <TextField name="username" value={data.username} onChange={handleChange} fullWidth variant="outlined" />
                ) : (
                  data.username
                )}
              </TableCell>
            </TableRow>
            <TableRow>
            <TableCell className="perTblLabel">Email Address:</TableCell>
            <TableCell className="perTbUsrInfo">
              {/* Always display email as plain text */}
              <Typography variant="body1">{data.email}</Typography>
            </TableCell>
          </TableRow>
            <TableRow>
              <TableCell className="perTblLabel">Phone Number:</TableCell>
              <TableCell className="perTbUsrInfo">
                {isEditing ? (
                  <TextField name="phone" value={data.phone} onChange={handleChange} fullWidth variant="outlined" />
                ) : (
                  data.phone
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="perTblLabel">Company:</TableCell>
              <TableCell className="perTbUsrInfo">
                {isEditing ? (
                  <TextField name="company" value={data.company} onChange={handleChange} fullWidth variant="outlined" />
                ) : (
                  data.company
                )}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {isEditing && (
        <Box sx={{ marginTop: 2 }}>
          <Button variant="contained" color="primary" onClick={handleUpdateClick}>
            Update
          </Button>
        </Box>
      )}
    </Box>
  );
}
